module.exports = __webpack_public_path__ + "img/facility_management.a8983308.webp";